import { useEffect } from "react";

export const useDocumentTitle = (title: string) => {
  useEffect(() => {
    const previous = document.title;
    document.title = title;
    const isInApp = Object.prototype.toString.call(window?.flutter_inappwebview?.callHandler) === '[object Function]';
    const setTitle = () => {
      if (isInApp) {
        window?.flutter_inappwebview?.callHandler?.('setTitle', title);
      }
    }
    if (isInApp) {
      setTitle();
    }
    window.addEventListener('flutterInAppWebViewPlatformReady', setTitle, false);
    return () => {
      document.title = previous;
      if (!!window?.flutter_inappwebview?.callHandler) {
        window?.flutter_inappwebview?.callHandler?.('setTitle', previous);
      }
      window.removeEventListener('flutterInAppWebViewPlatformReady', setTitle, false);
    };
  }, [title]);
}
